import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import { config } from '../../constants';



export default class UserItemComponent extends React.Component{
    
    changeUserStatus = (id) =>{
        axios.post(config.AUTH_URL + `user/change-user-status/${id}`,null, {headers: authHeader()}).then(
          response => {
                window.location.reload(false);
            }
        );
    }

    render(){
        
        return(
            <div className='index-list-item'>
                
                <p style={{width:"5"}}>{this.props.data.id}</p>
                <p style={{width:"18%"}}>{this.props.data.name}</p>
                <p style={{width:"18%"}}>{this.props.data.companyName}</p>
                <p style={{width:"18%"}}>{this.props.data.enabled ? '✔': '✘' }</p>

                <div className='config-buttons'>
                    <a href={"/update-user/" + this.props.data.id} className='config-btn config-edit-btn'>/</a>
                    <button className='config-btn config-send-btn' onClick={val => this.changeUserStatus(this.props.data.id)}>{this.props.data.enabled ? '✗': '✔' }</button>
                </div>

            </div>
        );
    }
}